<template>
  <layout-content>
    <tabs type="card" :animated="false" :value="$route.name" @on-click="set_tab">
      <tab-pane
        v-for="tab in tabs"
        :key="tab"
        :name="`mailer.message.${tab}`"
        :label="$t(`mailer.breadcrumb.message.tab.${tab}`)"
      />
    </tabs>
    <router-view />
  </layout-content>
</template>

<script>
  export default {
    data: () => ({
      tabs: ['index', 'setting']
    }),
    methods: {
      set_tab: function(name) {
        this.$router.push({
          name: name
        });
      }
    }
  };
</script>
